module.exports = __webpack_public_path__ + "img/puzzle.f7021658.svg";